import { isObject } from 'lodash';
import React from 'react';
import { theme } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';
import { FormContextType } from '../FormContext';
import { FormTextHelper } from '../types';
import { FORM_FOOTER_LINE_HEIGHT } from '../constants';

const getErrorMessage = (error) => {
  if (
    isObject(error) &&
    'message' in error &&
    (typeof error.message === 'string' || React.isValidElement(error.message))
  ) {
    return error.message;
  }
};

const getError = (error) => {
  const errorMessage = getErrorMessage(error);
  if (errorMessage) {
    return errorMessage;
  }
  if (isObject(error) && 'item' in error) {
    return getErrorMessage(error.item);
  }
  if (React.isValidElement(error) || typeof error === 'string') {
    return error;
  }
};
export const getMessage = ({
  isError,
  error,
  isSuccess,
  success,
  hint,
}: FormContextType): FormTextHelper['error'] | FormTextHelper['success'] | FormTextHelper['hint'] => {
  if (isError) {
    return getError(error);
  }

  if (isSuccess) {
    return success;
  }

  return hint;
};

export const getEmptyLines = (emptyLines?: FormTextHelper['emptyLines']) => {
  if (!emptyLines) {
    return null;
  }

  const lineHeightPx = Number.parseInt(theme.bodyLineHeights[FORM_FOOTER_LINE_HEIGHT], 10);
  if (Number.isNaN(lineHeightPx)) {
    return null;
  }

  const totalHeight = lineHeightPx * emptyLines;
  if (Number.isNaN(totalHeight)) {
    return null;
  }

  return <Container height={totalHeight} />;
};
